/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} CreatingInputs */

const en_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

const es_creating = /** @type {(inputs: CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando...`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {CreatingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const creating = /** @type {((inputs?: CreatingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<CreatingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creating(inputs)
	return es_creating(inputs)
});